module.exports = __webpack_public_path__ + "img/green-check.1a0f2b77.svg";